// Images, stylesheets, scripts, fonts and other loads via Resource Timing.
// Gives URL and timing. Size and status only appear for same-origin files or
// ones sent with Timing-Allow-Origin. Failed loads are caught by the errors hook.

import { shortUrl } from '../net-utils.js';

// Already captured in full by the fetch, XHR and beacon hooks.
const SKIP = new Set(['fetch', 'xmlhttprequest', 'beacon']);

export function installResources(ctx, win = window) {
  if (typeof win.PerformanceObserver !== 'function') return;
  const origin = performance.timeOrigin || Date.now() - performance.now();

  const observer = new win.PerformanceObserver((list) => {
    for (const entry of list.getEntries()) {
      try {
        if (SKIP.has(entry.initiatorType)) continue;
        if (ctx.isOwnUrl(entry.name)) continue;
        const status = typeof entry.responseStatus === 'number' ? entry.responseStatus : undefined;
        // Firefox lists the browser's own favicon request; a missing favicon is noise, not a site failure.
        const noise = /\/favicon\.ico(\?|$)/.test(entry.name) || undefined;
        const level = status && status >= 400 && !noise ? 'warn' : 'info';
        const duration = Math.round(entry.duration);
        ctx.push(
          'resource',
          level,
          `${entry.initiatorType || 'resource'} ${shortUrl(ctx.redact.url(entry.name))} ${status ? `${status} ` : ''}${duration}ms`,
          {
            url: ctx.redact.url(entry.name),
            initiatorType: entry.initiatorType,
            status,
            duration,
            transferSize: entry.transferSize || undefined,
            encodedBodySize: entry.encodedBodySize || undefined,
            decodedBodySize: entry.decodedBodySize || undefined,
            fromCache: entry.transferSize === 0 && entry.decodedBodySize > 0 ? true : undefined,
            protocol: entry.nextHopProtocol || undefined,
            renderBlocking: entry.renderBlockingStatus === 'blocking' ? true : undefined,
            noise,
          },
          Math.round(origin + entry.startTime),
        );
      } catch {
        // ignore a malformed entry
      }
    }
  });
  try {
    observer.observe({ type: 'resource', buffered: true });
  } catch {
    try {
      observer.observe({ entryTypes: ['resource'] });
    } catch {
      // not supported
    }
  }
}
